/*
 * Copyright (c) 2024-2025. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import React, {useEffect, useState} from "react";
import clsx from "clsx";
import {useTranslation} from "react-i18next";
import BookingPackageItemsWithKartingCountInput
    from "pages/Front/Booking/BookingPackageItems/BookingPackageItemsWithKartingCountInput";
import {BookingPackageKartingEnum} from "types/enums/BookingPackageKartingEnum";

export interface BookingPackageItemsWithKartingCountKartings {
    withKarting: number;
    withoutKarting: number;
}

interface BookingPackageItemsWithKartingCountProps {
    setKarting: (val: BookingPackageItemsWithKartingCountKartings) => void;
    karting: BookingPackageItemsWithKartingCountKartings;
    personCount: number;
    className?: string;
}

const BookingPackageItemsWithKartingCount = (props: BookingPackageItemsWithKartingCountProps) => {
    const {t} = useTranslation();
    const [karting, setKarting] = useState<BookingPackageItemsWithKartingCountKartings>({
        withKarting: 0,
        withoutKarting: 0,
    });

    const setKartingHandler = (kartingCount: number, kartingType: BookingPackageKartingEnum) => {
        const newCount = props.personCount - kartingCount;
        if (kartingType === BookingPackageKartingEnum.WithKarting) {
            return props.setKarting({withKarting: kartingCount, withoutKarting: newCount});
        }
        return props.setKarting({withKarting: newCount, withoutKarting: kartingCount});
    };

    // useEffect(() => {
    //     console.log("props.personCount", props.personCount);
    // }, [props.personCount]);

    useEffect(() => {
        setKarting({withKarting: props.karting.withKarting, withoutKarting: props.karting.withoutKarting});
    }, [props.karting]);

    return (
        <div className={clsx("BookingPackageItemsWithKartingCount flex w-full gap-3", props.className)}>
            <BookingPackageItemsWithKartingCountInput
                karting={karting.withoutKarting}
                label={t("without Karting")}
                maxCount={props.personCount}
                setKarting={e => setKartingHandler(e, BookingPackageKartingEnum.WithoutKarting)}
            />
            <BookingPackageItemsWithKartingCountInput
                karting={karting.withKarting}
                label={t("with Karting")}
                maxCount={props.personCount}
                setKarting={e => setKartingHandler(e, BookingPackageKartingEnum.WithKarting)}
            />
        </div>
    );
};

export default BookingPackageItemsWithKartingCount;
